import { Injectable } from "@angular/core";
import { Observable, bindCallback } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ZendeskWebwidgetService {
	open$: Observable<void> | undefined;
	close$: Observable<void> | undefined;

	private scheduled: { noun: string; verb: string; data?: any }[] = [];

	constructor() {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.id = "ze-snippet";
		script.src =
			"https://static.zdassets.com/ekr/snippet.js?key=4e3a5eba-44df-40af-8d90-0bc0e1cce89a";
		script.onload = () => {
			this.open$ = bindCallback(this.onEvent)("open");
			this.close$ = bindCallback(this.onEvent)("close");
			this.executeScheduled();
		};
		document.getElementsByTagName("head")[0].appendChild(script);
		(window as any).zESettings = {
			webWidget: {
				color: { theme: "#044274" },
				offset: { horizontal: "37px", vertical: "37px" },
			},
		};
	}

	public openWidget = () => this.zE("webWidget", "open");
	public showWidget = () => this.zE("webWidget", "show");
	public hideWidget = () => this.zE("webWidget", "hide");

	public prefillWidget = (prefill: { name?: { value?: string } }) =>
		this.zE("webWidget", "prefill", prefill);

	private onEvent = (event: string, callback: () => any): void =>
		this.zE("webWidget:on", event, callback);

	public onClose = (callback: () => any) => this.onEvent("close", callback);

	zE = (noun: string, verb: string, data?: any) => {
		if (!!(window as any).zE) {
			(window as any).zE(noun, verb, data);
		} else {
			this.scheduled.push({ noun, verb, data });
		}
	};

	executeScheduled(): void {
		while (this.scheduled.length > 0) {
			const scheduled = this.scheduled.shift();
			this.zE(scheduled.noun, scheduled.verb, scheduled.data);
		}
	}
}
